/**
 * Organization Routes
 *
 * Defines routes for organization listing, creation, and acceptance of invitations.
 * These routes are placed outside the main layout since they don't require
 * organization context or are used before organization selection.
 *
 * Main routes:
 * - /organizations - Organization list/onboarding
 * - /organizations/create - Create new organization
 * - /invitations/accept - Accept organization invitation (defined in app.routes.ts)
 *
 * Routes for organization-scoped views are defined in app.routes.ts:
 * - /organizations/:slug/dashboard - Organization dashboard
 * - /organizations/:slug/campaigns - Organization campaigns
 * - /organizations/:slug/database - Organization database
 * - /organizations/:slug/settings - Organization settings
 */

import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/guards/auth.guard';

export const organizationRoutes: Routes = [
  // Organization Onboarding/List Page
  {
    path: 'organizations',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/organization-onboarding/organization-onboarding').then(
        (m) => m.OrganizationOnboarding,
      ),
    data: { title: 'Organisationen' },
  },

  // Create New Organization
  {
    path: 'organizations/create',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/create-organization/create-organization').then(
        (m) => m.CreateOrganization,
      ),
    data: { title: 'Organisation erstellen' },
  },

  // Note: Organization-scoped routes (dashboard, campaigns, settings, etc.)
  // are defined in app.routes.ts under the Layout component for consistency
];
